<template>
    <bc-dialog :value="entity_note_dialog" max-width="600">
        <v-card>
            <v-card-title>
                <span class="headline">{{ currObjField("note_id") ? $t("lang.note_details") : $t("lang.add_note") }}</span>
                <v-spacer></v-spacer>
                <bc-btn-dialog-close @invoke-method="invokeMethod($event)" :dialog-status="entity_note_dialog" action="close"></bc-btn-dialog-close>
            </v-card-title>
            <v-card-text>
                <v-form ref="entity_note">
                    <v-container grid-list-form>
                        <v-layout row wrap v-if="!currObjField('note_id') || (this.current_obj && this.current_obj.editable == 1)">
                            <v-flex xs12>
                                <v-textarea
                                    v-focus="entity_note_dialog"
                                    v-model="entity_note.note"
                                    :label="$t('lang.notes')"
                                    auto-grow
                                    rows="1"
                                    :key="growText"
                                    :rules="ifValid('entity_note.note')"
                                ></v-textarea>
                            </v-flex>
                        </v-layout>
                        <v-layout column v-else>
                            <v-flex py-0 fs-18>{{ currObjField("created_by") }}</v-flex>
                            <v-flex pt-0 fs-14>{{ currObjField("date_created") }}</v-flex>
                            <v-flex fs-26 style="white-space: pre-line">{{ currObjField("note") }}</v-flex>
                        </v-layout>
                    </v-container>
                </v-form>
                <delete-confirmation-dialog
                    ref="delete_entity_note"
                    :heading="$t('lang.delete_note')"
                    :message="$t('lang.confirm_delete_message')"
                    @onConfirm="deleteModuleNote(currObjField('note_id'))"
                ></delete-confirmation-dialog>
            </v-card-text>
            <v-card-actions>
                <v-btn v-if="currObjField('editable') == '1' && currObjField('note_id')" color="error" @mouseup.left="$refs.delete_entity_note.openDialog()">{{
                    $t("lang.delete")
                }}</v-btn>
                <v-spacer></v-spacer>
                <v-btn flat @mouseup.left="close()">{{ $t("lang.cancel") }}</v-btn>
                <v-btn
                    v-if="(!currObjField('note_id') && hasScope('create')) || (this.current_obj && this.current_obj.editable == 1)"
                    color="success"
                    @mouseup.left="modifyEntityNote(currObjField('note_id') ? 'patch' : 'post', currObjField('note_id'))"
                >
                    {{ $t("lang.save") }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </bc-dialog>
</template>
<script>
import { mapState } from "vuex";
import _ from "lodash";
import { mapActions } from "vuex";

export default {
    props: {
        entityObject: {
            // object name matching store
            type: String,
            required: true,
        },
        scope: {
            // scope from parent
            type: String,
            default: null,
        },
        apiUrl: {
            // url that `/notes/${notes_id}` appends to for modifying note
            type: String,
            required: true,
        },
        stateProperty: {
            type: String,
            required: true,
        },
        stateMutate: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            entity_note: {
                note: "",
            },
            current_obj: null,
            entity_note_dialog: false,
            growText: 0,
        };
    },
    computed: {
        ...mapState({
            rules_entity_note: (state) => state.validation.rules_entity_note,
        }),
        fetchObject() {
            // use entity_object to create store action
            return `fetch${_.upperFirst(_.camelCase(this.entityObject))}`;
        },
        currObjField() {
            return (field) => {
                return this.current_obj && field && this.current_obj[field] ? this.current_obj[field] : "";
            };
        },
        hasScope() {
            return (scope) => {
                return !this.scope || this.scope.includes(`${scope}`) || !this.currObjField("note_id");
            };
        },
    },
    methods: {
        ...mapActions(["saveModuleNote", "removeModuleNote"]),
        setNote(note = { note: "" }) {
            this.entity_note = note;
        },
        close() {
            this.entity_note_dialog = false;
            if (this.$refs.delete_entity_note) this.$refs.delete_entity_note.close();
            this.$store.commit("toggleModalLoader", false);
        },
        modifyEntityNote(method = null, id = null) {
            let body = {
                note: this.entity_note.note,
                note_id: id,
                module: this.entityObject,
                module_id: this.$route.params.id,
            };
            this.saveModuleNote({ body: body }).then((data) => {
                this.$store.commit(this.stateMutate, {
                    property: this.stateProperty,
                    with: data.notes,
                });
                this.close();
            });
            // console.log(this.entity_note);
            // if (method) {
            //     this.$nextTick(() => {
            //         this.$store.commit("toggleModalLoader", true);
            //         this.$store
            //             .dispatch(this.fetchObject, {
            //                 pk: "note_id",
            //                 id: id,
            //                 url: `${this.apiUrl}/notes/${id ? id : ""}`,
            //                 method: method,
            //                 stateProperty: this.stateProperty,
            //                 dataProperty: "notes",
            //                 mutate: true,
            //                 body: method != "delete" ? this.entity_note : null,
            //             })
            //             .then((data) => {
            //                 if (data && data.code == "200") {
            //                     this.close();
            //                 } else {
            //                     this.$store.commit("toggleModalLoader", false);
            //                 }
            //             });
            //     });
            // }
        },
        deleteModuleNote(id) {
            let body = {
                note_id: id,
                module: this.entityObject,
                module_id: this.$route.params.id,
            };
            this.removeModuleNote({ body: body }).then((data) => {
                this.$store.commit(this.stateMutate, {
                    property: this.stateProperty,
                    with: data.notes,
                });
                this.close();
            });
        },
        showNote(item = null) {
            this.current_obj = item;

            if (this.$refs.entity_note) item ? this.$refs.entity_note.resetValidation() : this.$refs.entity_note.reset();

            this.$nextTick(() => {
                this.assignObj(this.entity_note, item, this.rules_entity_note);
                this.entity_note_dialog = true;
                this.growText++;
            });
        },
    },
};
</script>
